import { useGetDoctorsByKeywordQuery } from '@/hooks/search/search.gql.impl';
import { parseKeywordIntegratedDoctorVo } from '@/parsers/search';

const KEYWORD_SEARCH_SIZE = 4;

const useGetKeywordIntegratedSearchDoctor = (keyword: string) => {
  const { data: keywordSearchDoctor } = useGetDoctorsByKeywordQuery(
    {
      request: {
        keyword,
        size: KEYWORD_SEARCH_SIZE,
      },
    },
    {
      select: (data) => parseKeywordIntegratedDoctorVo(data),
      enabled: keyword.length > 0,
    },
  );

  return {
    keywordSearchDoctor,
  };
};

export default useGetKeywordIntegratedSearchDoctor;
